<template>
  <div class="form-group">
    <w-terc-picker
      :woj-model="wojSchema"
      :pow-model="powSchema"
      :gmi-model="gmiSchema"
      :terc-model="tercSchema"
      :url="url"
      :empty-list-msg="emptyListMsg"
      :show-error="showError"
      :type-terc="typeTerc"
      :disabled="disabled"
      @selectedWoj="$emit('selectedWoj', $event)"
      @selectedPow="$emit('selectedPow', $event)"
      @selectedGmi="$emit('selectedGmi', $event)"
      @error="$emit('error', $event)"
      @update="$emit('update')"
    />

    <div class="row">
      <div class="col-sm-12 col-lg">
        <w-simc-picker
          :city-model="citySchema"
          :simc-model="simcSchema"
          :url="url"
          :terc="tercSchema.$value"
          :empty-list-msg="emptyListMsg"
          :show-error="showError"
          :disabled="disabled || cityDisabled"
          @selectedCity="$emit('selectedCity', $event)"
          @error="$emit('error', $event)"
          @update="$emit('update')"
        />
      </div>

      <div v-if="postCodeSchema && !postCodeSchema.$disabled" class="col-sm-12 col-lg">
        <w-input :model="postCodeSchema" :disabled="disabled || cityDisabled" @input="$emit('update')" />
      </div>

      <div v-if="postSchema && !postSchema.$disabled" class="col-sm-12 col-lg">
        <w-input :model="postSchema" :disabled="disabled || cityDisabled" @input="$emit('update')" />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-lg-6">
        <w-ulic-picker
          :street-model="streetSchema"
          :ulic-model="ulicSchema"
          :url="url"
          :terc="tercSchema.$value"
          :simc="simcSchema.$value"
          :city="citySchema.$value"
          :placeholder="cityPlaceholder"
          :empty-list-msg="emptyListMsg"
          :show-error="showError"
          :disabled="disabled"
          :search-split="streetSearchSplit"
          :search-any="streetSearchAny"
          :set-city-as-street="setCityAsStreet"
          :street-list-on-city-select="streetListOnCitySelect"
          @selectedStreet="$emit('selectedStreet', $event)"
          @error="$emit('error', $event)"
          @update="$emit('update')"
        />
      </div>

      <div v-if="nrSchema && !nrSchema.$disabled" class="col-sm-6 col-lg-3">
        <w-input :model="nrSchema" :disabled="disabled || streetDisabled" @input="$emit('update')" />
      </div>

      <div v-if="localNrSchema && !localNrSchema.$disabled" class="col-sm-6 col-lg-3">
        <w-input :model="localNrSchema" :disabled="disabled || streetDisabled" @input="$emit('update')" />
      </div>
    </div>
  </div>
</template>

<script>
import WTercPicker from './tercPicker.vue';
import WSimcPicker from './simcPicker.vue';
import WUlicPicker from './ulicPicker.vue';
import wInput from './input';

// @vuese
// Input na adres razem z TERYT
// @group Components
export default {
  name: 'WAddressPicker',
  components: { WTercPicker, WSimcPicker, WUlicPicker, wInput },
  props: {
    // URL do TERYT API
    url: { type: String, required: false, default: 'https://teryt.api.witkac.pl' },
    // Schema
    model: { type: Object, required: false },
    // Schema województwa
    wojModel: { type: Object, required: false },
    // Schema powiatu
    powModel: { type: Object, required: false },
    // Schema gminy
    gmiModel: { type: Object, required: false },
    // Schema tercu
    tercModel: { type: Object, required: false },
    // Schema SIMCu
    simcModel: { type: Object, required: false },
    // Schema miasta
    cityModel: { type: Object, required: false },
    // Schema kodu pocztowego
    postCodeModel: { type: Object, required: false },
    // Schema poczty
    postModel: { type: Object, required: false },
    // Schema kodu ULIC
    ulicModel: { type: Object, required: false },
    // Schema ulicy
    streetModel: { type: Object, required: false },
    // Schema numeru posesji
    nrModel: { type: Object, required: false },
    // Schema numeru lokalu
    localNrModel: { type: Object, required: false },
    // Placeholder dla ulic
    cityPlaceholder: { type: String, required: false, default: '' },
    // Tekst do wyświetlenia w przypadku pustej listy
    emptyListMsg: { type: String, required: false, default: '' },
    // Czy pokazywać błędy
    showError: { type: Boolean, default: true },
    // Czy pobierać pełny terc
    typeTerc: { type: Boolean, default: false },
    // Czy nieaktywny
    disabled: { type: Boolean, default: false },
    // Czy używać wyszukiwania w ulicach po każdym słowie osobno (niezależnie od kolejności)
    streetSearchSplit: { type: Boolean, default: true },
    // Czy wyszukiwać ulice po dowolnym słowie (minimum 1 słowo się zgadza)
    streetSearchAny: { type: Boolean, default: false },
    // Czy ustawiać miasto jako ulicę, gdy nie ma ulic w mieście
    setCityAsStreet: { type: Boolean, default: true },
    // Czy wyświetlać listę ulic po wybraniu miasta
    streetListOnCitySelect: { type: Boolean, default: false }
  },
  computed: {
    wojSchema() {
      return this.wojModel || this.model.woj;
    },
    powSchema() {
      return this.powModel || this.model.pow;
    },
    gmiSchema() {
      return this.gmiModel || this.model.gmi;
    },
    tercSchema() {
      return this.tercModel || this.model.terc;
    },
    simcSchema() {
      return this.simcModel || this.model.simc;
    },
    citySchema() {
      return this.cityModel || this.model.city;
    },
    postCodeSchema() {
      return this.postCodeModel || this.model.postCode;
    },
    postSchema() {
      return this.postModel || this.model.post;
    },
    ulicSchema() {
      return this.ulicModel || this.model.ulic;
    },
    streetSchema() {
      return this.streetModel || this.model.street;
    },
    nrSchema() {
      return this.nrModel || this.model.nr;
    },
    localNrSchema() {
      return this.localNrModel || this.model.localNr;
    },
    cityDisabled() {
      return this.tercSchema.$value.length < 6;
    },
    streetDisabled() {
      return !(!!this.tercSchema.$value && !!this.simcSchema.$value);
    }
  }
};
</script>
